import { render } from "./FlatButton.vue?vue&type=template&id=6e3a9e21&scoped=true&ts=true"
import script from "./FlatButton.vue?vue&type=script&lang=ts"
export * from "./FlatButton.vue?vue&type=script&lang=ts"

import "./FlatButton.vue?vue&type=style&index=0&id=6e3a9e21&scoped=true&lang=scss"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3a9e21"]])

export default __exports__